import { BasemapFormat, BasemapStyleSettings } from 'features/maps/types'
import { StyleSpecification } from 'maplibre-gl'

export const DEFAULT_BASEMAP_RASTER_TILE_SIZE = 256

export const getRasterMapJsonStyle = (settings: BasemapStyleSettings): StyleSpecification => ({
  version: 8,
  sources: {
    'basemap-tile-source': {
      type: 'raster',
      tiles: [settings.url],
      tileSize: settings.tileSize || DEFAULT_BASEMAP_RASTER_TILE_SIZE
    }
  },
  layers: [
    {
      id: 'basemap-tiles',
      type: 'raster',
      source: 'basemap-tile-source',
      minzoom: 0,
      maxzoom: 22
    }
  ]
})

function isRasterBasemap(url: string) {
  return /.*(?=.*\{z\})(?=.*\{x\})(?=.*\{y\}).*/.test(url)
}

function isTileJsonBasemap(url: string) {
  return /.*(.json)/.test(url) && !url.includes('service=WMS')
}

function isWmtsBasemap(url: string) {
  return url.includes('service=WMS')
}

export function basemapFormatFromUrl(url: string): BasemapFormat {
  if (isRasterBasemap(url)) {
    return BasemapFormat.Raster
  } else if (isTileJsonBasemap(url)) {
    return BasemapFormat.TileJson
  } else if (isWmtsBasemap(url)) {
    return BasemapFormat.WMTS
  }
  throw new Error('Unknown basemap format')
}

export function getBasemap(settings: BasemapStyleSettings): {
  format: BasemapFormat
  style: string | StyleSpecification
} {
  const url = settings.url
  const format = basemapFormatFromUrl(url)
  switch (format) {
    case BasemapFormat.Raster:
    case BasemapFormat.WMTS:
      return { format, style: getRasterMapJsonStyle(settings) }
    case BasemapFormat.TileJson:
      return { format, style: url }
    default:
      throw new Error('Unknown basemap format')
  }
}
